<template>
<div class="new">
  <div class="container">
    <div :class="{list:true,lister:listshow}">
      <span class="title">
        {{news.NEW_TITLE}}
      </span>
      <div class="text">
        {{news.NEW_TEXT}}
      </div>
      <!-- <div class="corner">
      </div> -->
    </div>
      <div class="container-item">
        <div :class="{itemo:true,itemoerboth:itemoershow}">
          <div class="itemo-list">
            <div class="itemo-color">
              <img :src="news.NEW_IMG" alt="" />
              <div class="one">{{ news.NEW_ITEM_TITLE }}</div>
              <ul>
                <li
                  v-for="(art, idx) in newList.slice(0,3)"
                  :key="'news-'+idx"
                  class="itemo-cent">
                  <div class="span1"></div>
                  <router-link :to="'/policy/view/'+art.index" class="span2">{{art.con}}</router-link>
                  <div class="span3">{{art.data}}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div :class="{itemo:true,itemoer:itemoershow}">
          <div class="itemo-list">
            <div class="itemo-color">
              <img :src="news.NEW_IMG1" alt="" />
              <div class="one">{{news.NEW_ITEM_TITLE2}}</div>
              <ul>
                <li
                  v-for="(art, idx) in newList.slice(3,6)"
                  :key="'news-'+idx"
                  class="itemo-cent">
                  <div class="span1"></div>
                  <!-- <a href="" class="span2">{{art.con}}</a> -->
                  <router-link :to="'/policy/view/'+art.index" class="span2">{{art.con}}</router-link>
                  <div class="span3">{{art.data}}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div :class="{itemo:true,itemoerboth:itemoershow}">
          <div class="itemo-list">
            <div class="itemo-color">
              <img :src="news.NEW_IMG2" alt="" />
              <div class="one">{{news.NEW_ITEM_TITLE3}}</div>
              <ul>
                <li
                  v-for="(art, idx) in newList.slice(6,7)"
                  :key="'news-'+idx"
                  class="itemo-cent">
                  <div v-if="art.data != ''" class="span1"></div>
                  <!-- <a href="" class="span2">{{art.con}}</a> -->
                  <router-link :to="'/policy/view/'+art.index" class="span2">{{art.con}}</router-link>
                  <div class="span3">{{art.data}}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      listshow: false,
      itemoershow: false,
      news: [],
      newList: []
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    axios.get(`https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/configes.json`)
      .then(response => {
        this.news = response.data.NEW
        this.newList = response.data.NEW.NEW_SPAN2
        // console.log(this.newList)
      })
  },
  methods: {
    handleScroll () {
      this.currentScroll = window.pageYOffset
      if (this.currentScroll > 1600) {
        this.itemoershow = true
      }
      if (this.currentScroll >= 1600) {
        this.listshow = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
//>1100
@import url('../../static/less/less.css');
// @keyframes FadeUp{
//   from {bottom: -30px;}
//   to {bottom: 0px;}
// }
// @keyframes FadeUpone{
//   0% {
//     opacity: 0;
//     transform:translateY(80%)
//   }
//   100% {
//     opacity: 1;
//     transform: none
//   }
// }
// @keyframes fadeDown {
//   0% {
//     opacity: 0;
//     transform: translateY(-80%)
//   }
//   100% {
//     opacity: 1;
//     transform: translateY(0)
//   }
// }
@media only screen and (min-width: 960px) {
  .container-item {
    display: flex;
    justify-content: space-between;
  }
  .itemo {
    width: 27%;
    // height: 310px;
    float: left;
    // margin-right: 20px;
    img {
    height: 77px;
  }
  }
  .list {
    margin-bottom: 50px;
    .title {
      font-size: 27px;
    }
    .text {
      font-size: 16px;
    }
  }
}
@media only screen and (min-width: 767px) and (max-width: 960px) {
  .itemo {
    width: 25%;
    // height: 310px;
    float: left;
    margin: 0 0 0 50px;
    // margin-right: 20px;
    img {
    height: 77px;
  }
  }
  .list {
    margin-bottom: 30px;
    .title {
      font-size: 25px;
    }
    .text {
      font-size: 16px;
    }
  }
}
//<1100
@media only screen and (max-width: 767px) {
  .itemo {
    width: 100%;
    // height: 310px;
    float: left;
    // margin-right: 20px;;
    img {
    height: 120px;
  }
  }
  .list {
    margin-bottom: 30px;
    .title {
      font-size: 25px;
    }
    .text {
      font-size: 16px;
    }
  }
}
h1,
h2 {
  font-weight: normal;
}
ul {
  // list-style-type: none;
  padding: 0;
}
li {
  width: 100%;
  float: left;
}
a {
  color: #2ec4b6;
}
.new {
  padding: 100px 0;
  // background-color: #1c85f3;
  // background: url();
  // text-align: center;
  // min-width: 1200px;
  display: flex;
}
.demo {
  text-align: center;
  margin: 20px;
}
.buttondemo {
  background-color: #2ec4b6;
  width: 120px;
  height: 35px;
  border: none;
  cursor: pointer;
  color: #fdfffc;
}
.container {
  width: 96%;
  // padding: 55px 10% 60px 10%;
  // background-color: #fdfffc;
  margin: 0 auto;
  max-width: 1200px;
  .lister {
    position: relative;
    animation-name: FadeUp;
    animation-duration: 1.5s;
    opacity: 1 !important;
  }
  .list {
    opacity: 0;
    text-align: center;
    // margin-bottom: 40px;
    .title {
      // font-size: 25px;
      color: #333;
    }
    .text {
      color: #818181;
    }
  }
  .corner {
    // padding-top: 10px;
    margin: 15px auto;
    width: 0;
    height: 0;
    border: 10px solid #ff9f1c;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
  }
  &-item {
    clear: both;
    width: 100%;
    // padding: 40px 0 22px;
    // margin-top: 60px;
    // display: flow-root;
    // margin-left: -60px;
    .itemoerboth {
      visibility: visible;
      animation-name: fadeDown;
      animation-duration: 1.2s;
      animation-delay:1s;
      animation-fill-mode: both;
      }
    .itemoer {
      visibility: visible;
      // position: relative;
      animation-name: FadeUpone;
      animation-duration: 1.2s;
      animation-delay: 0.7s;
      animation-fill-mode: both;
      }
    .itemo {
      // width: 33.33333333%;
      // margin-top: 20px;
      // width: 350px;
      // height: 310px;
      // float: left;
      opacity: 0.1;
      // margin-left: 60px;
      position: relative;
      transition: all 0.3s;
      // border: 1px solid #e5e5e5;
      // box-sizing: border-box;
      // text-align: center;
      .span1 {
        display: block;
        width: 0;
        height: 0;
        border-top: 5px solid transparent;
        border-left: 10px solid;
        border-bottom: 5px solid transparent;
        color: #8f8f8f;
        float: left;
        margin: 8px 6px 0 0;
      }
      a {
        display: block;
        color: #767676;
        font-size: 15px;
        margin-bottom: 10px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        padding: 3px 0;
        transition: 0.2s all;
        width: 75%;
        float: left;
      }
      a:hover {
        // border: 1px solid #26bbfb;
        color: #333;
        text-indent: 5px;
      }
      .span3 {
        font-size: 12px;
        color: #ccc;
        float: right;
        margin-top: 3px;
      }
      .itemo-color {
        overflow: hidden;
        img {
          width: 100%;
          // height: 77px;
          transition: 0.3s all
        }
        img:hover {
        transform: scale(1.1);
      }
        // background-color: #eee;
        // height: 80%;
      }
      .one {
        // width: 100%;
        // height: 155px;
        // background: rgba(116, 116, 156, 1.7);
        // background-size: cover;
        // background-position: center;
        // padding-top: 45px;
        font-size: 16px;
        color: #333;
        margin: 25px 0;
        text-align: left;
        // box-sizing: border-box;
      }
      .two {
        font-size: 16px;
        line-height: 65px;
        // height: 95px;
        color: #011627;
        height: 20%;
        // padding: 0 10% 0 10%;
        background-color: lavender;
      }
      .button {
        font-size: 14px;
        // padding: 10px 0 10px 0;
        display: block;
        width: 105px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #fff;
        border-radius: 15px;
        background: #26bbfb;
        margin: 0 auto;
        margin-top: 20px;
        // font-size: 13px;
        // margin-top: 30px;
        // background-color: lavender;
        // padding: 10px 0 10px 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/new.vue